import { send } from 'server';
import { IServerSendResponse } from 'js/hooks/socket/types';
import * as Types from './types';

export const initiateDocumentUploadRequest = (): Promise<Types.TInitiateDocumentUploadResponse> => send({
    ID: 35688,
    description: 'Initiate document upload request',
    responses: [35689, 35690],
    profile: 'portal',
    service: 'identt',
    documentType: 'attachment'
});

export const setUploadedDocumentUrlRequest = (
    url: string,
    documentId: string
): Promise<IServerSendResponse> => send({
    ID: 35802,
    description: 'Set uploaded document url request',
    responses: [35803, 35804],
    URL: url,
    documentId
});

export const uploadFile = ({
    url,
    file,
    accessToken,
    reference
}: Types.IUploadFileConfig): Promise<IServerSendResponse> => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const formData = new FormData();

    formData.set('file', file);

    return fetch(url, {
        method: 'POST',
        body: formData,
        headers
    })
        .then(response => {
            if (response.ok) {
                return response.json();
            }

            throw {
                data: {
                    errorCode: -1
                }
            };
        })
        .then(data => {
            const { file: fileUrl } = data;

            return setUploadedDocumentUrlRequest(fileUrl, reference);
        });
};
